import { Box, BoxProps, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { FC } from 'react'
import { SvgImage } from '../../comps/SvgImage'
import { staticStrings } from '../../data/static/strings'
import { Routes } from '../../nav/routes'
import { Colors } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { styles } from './styles'

interface ImageWithInfoSerializerInterface {
  onPress?: () => void
  style?: BoxProps | Array<BoxProps>
  show?: boolean
  screenName: string
  actionButtonVisible?: boolean
  actionButtonName?: string
  searchString?: string
  message?: string
  messageLabel?: string
}

const labelText = (screenName: string, message: string, messageLabel: string) => {
  let label = '',
    description = ''
  let image = 'NoTransaction'
  switch (screenName) {
    case Routes.TRANSACTIONS:
      label = staticStrings.showTransaction
      description = staticStrings.noDataTransDesc
      image = 'errorTxn'
      break
    case Routes.REFUNDS:
      label = staticStrings.noRefunds
      description = staticStrings.noRefundDesc
      image = 'errorTxn'
      break

    case Routes.QR_CODE:
      label = staticStrings.noDataQrCode
      description = staticStrings.noDataSettlementDesc
      image = 'errorTxn'
      break

    case Routes.SETTLEMENTS:
      label = staticStrings.showSettlementEmpty
      description = staticStrings.noDataSettlementDesc
      image = 'errorTxn'
      break

    case Routes.HOME:
      label = staticStrings.noDataRecent
      description = ''
      image = 'NoSettlement'
      break
    case Routes.SEARCH:
      label = "Couldn't find any result for"
      description = 'Try searching with a different word or number'
      image = 'NoSearchResult'
      break

    case 'errorOperatorList':
      label = 'Something went wrong'
      description = 'Unable to process the request now.'
      image = 'errorTxn'
      break
    case 'emptyOperatorList':
      label = messageLabel ?? 'There are no operators available currently'
      description = message ?? 'We’ll come back soon with some operators'
      image = 'errorTxn'
      break

    case Routes.BILL_PAYMENTS_TRANSACTIONS:
      label = staticStrings.showTransaction
      description = staticStrings.noBillPayments
      image = 'errorTxn'
      break

    case 'errorTxn':
      label = 'Something went wrong'
      description = 'Please retry to view the payments.'
      image = 'errorTxn'
      break

    default:
      label = staticStrings.noDataRecent
      description = ''
      break
  }
  return { description, label, image }
}

const ImageWithInfoSerializer: FC<ImageWithInfoSerializerInterface> = ({
  show = true,
  screenName = Routes.HOME,
  actionButtonVisible = false,
  onPress,
  actionButtonName = 'Refresh',
  searchString = '',
  messageLabel,
  message,
}) => {
  const imageHeader = () => {
    return (
      <Box pt={24} maxWidth={'80%'}>
        <Text {...styles.labelStyle}>
          {`${labelText(screenName, message, messageLabel).label}${isEmpty(searchString) ? '' : ' ' + searchString}`}
        </Text>
      </Box>
    )
  }

  const imageDescription = () => {
    const text = labelText(screenName, message, messageLabel).description
    return (
      <ModBox show={screenName !== Routes.HOME || text?.length > 1} pt={8}>
        <Text {...styles.descStyle}>{text}</Text>
      </ModBox>
    )
  }

  const actionButton = () => {
    return (
      <ModBox {...styles.button} show={actionButtonVisible} testID={'btn-' + actionButtonName} onPress={onPress}>
        <Text {...styles.buttonText}>{actionButtonName}</Text>
      </ModBox>
    )
  }

  const imageView = () => {
    //FIXME: Add the exportable images
    return (
      <ModBox {...styles.imageContainer}>
        <SvgImage color={Colors.PRIMARY} imageName={labelText(screenName, message, messageLabel).image} />
        <ModBox show={screenName === 'errorTxn'} w={24} h={24} zIndex={10} position={'absolute'} top={20} right={0}>
          <SvgImage imageName="errorbadge" />
        </ModBox>
      </ModBox>
    )
  }

  if (!show) {
    return null
  }
  return (
    <Box {...styles.container}>
      {imageView()}
      {imageHeader()}
      {imageDescription()}
      {actionButton()}
    </Box>
  )
}

export { ImageWithInfoSerializer }
